import { CaseFormFooter, CaseSummaryLink, Dialog, RenderIf } from './index';
import { caseFormContainerClasses } from './common/caseListClasses';
import Progressbar from '../pages/admin/cases/component/Progressbar';
import Tabs from './ui-control/tabs';
import FinalizeCaseLink from './ui-control/FinalizeCaseLink';
import XLoader from "./common/XLoader";
import ChatWindow from "../pages/chatBot/ChatWindow";
import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';
import DemandStudioButton from "../components/demand-studio/DemandStudioButton";
import useSuggestedEditsFeatureFlag from "../hooks/useSuggestedEditsFeatureFlag";
import useCertifiedLifecareCompany from "../hooks/useCertifiedLifecareCompany";
import { pageTitleClasses } from './common/PageTitle';
import EditCaseTour from './tour/EditCaseTour';

// Opaque so the form scrolls under the stepper without tinting the page.
const stickyStepperClasses = 'sticky top-0 z-[3] bg-surface mt-4';

const AddCaseFormContent = () => {
  const {
    formik,
    isLoading,
    selectedTiffIndex,
    setSelectedTiffIndex,
    selectedDefendant,
    setSelectedDefendant,
    isChatOpen,
    caseId,
    isWaitingForPresignedUrls,
    presignedUrlGenerationCount,
    FormComponent,
    showClientTabs,
    showDefendantTabs,
  } = useAddCaseFormContext();

    const isSuggestedEditsUiEnabled = useSuggestedEditsFeatureFlag();
    const isCertifiedLifecareCompany = useCertifiedLifecareCompany();



  return (
    <>
      <section>
        <div className={`layout-wrapper ${isChatOpen ? 'chat-open' : ''}`}>
          <ChatWindow caseId={caseId} isOpen={isChatOpen} />
          <div className={`container ${caseFormContainerClasses}`}>
            <div className="listing">
              <div className='container p-0!'>
                <RenderIf shouldRender={isLoading}>
                  <div className='flex justify-center'>
                    <XLoader />
                  </div>
                </RenderIf>
                <RenderIf shouldRender={!isLoading}>
                  <div>
                    <div className='flex items-baseline gap-4'>
                      <h1 className={`${pageTitleClasses} mb-0! mt-4! ml-4`}>Create Case</h1>
                      {isCertifiedLifecareCompany ? (
                        <span className="w-auto [&>a]:w-auto relative -top-1">
                          <FinalizeCaseLink caseId={caseId} />
                        </span>
                      ) : (
                        <span className="w-auto [&>a]:w-auto relative -top-1">
                          <CaseSummaryLink caseId={caseId} hideOnInit={false} />
                        </span>
                      )}
                      {isSuggestedEditsUiEnabled && !isCertifiedLifecareCompany && (
                        <span className="w-auto [&>a]:w-auto relative -top-1">
                          <DemandStudioButton caseId={caseId} disabled={formik?.values?.isDraftCase} />
                        </span>
                      )}
                    </div>

                    {/* Sticky Header with Progress Bar and Tabs */}
                    <div className={stickyStepperClasses}>
                      <Progressbar />

                      {/* Client Tabs */}
                      <RenderIf shouldRender={showClientTabs}>
                        <Tabs
                          tabList={formik.values.clients.map(t => ({ ...t, name: t.personalInfo?.clientName }))}
                          selectedTabIndex={selectedTiffIndex}
                          onTabChange={(index) => setSelectedTiffIndex(index)}
                        />
                      </RenderIf>

                      {/* Defendant Tabs */}
                      <RenderIf shouldRender={showDefendantTabs}>
                        <Tabs
                          tabList={formik.values.defendants.map(d => ({ ...d, name: d.personalInfo?.name }))}
                          selectedTabIndex={selectedDefendant}
                          onTabChange={(index) => setSelectedDefendant(index)}
                        />
                      </RenderIf>

                    </div>

                    {/* Form Content */}
                    {FormComponent && <FormComponent />}
                  </div>

                  {/* Case Footer */}
                  <CaseFormFooter />
                </RenderIf>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RenderIf shouldRender={isWaitingForPresignedUrls}>
        <Dialog onToggleDialog={() => { }} isModalOpen={isWaitingForPresignedUrls} mode="small-half" isCloseIconHidden={false}>
          <div className="flex flex-col items-center mt-8">
            <h3 className="title">Preparing files for upload...</h3>
            <p className="mt-4 text-body">
              {presignedUrlGenerationCount} {presignedUrlGenerationCount === 1 ? 'file' : 'files'} remaining
            </p>
          </div>
          <XLoader />
        </Dialog>
      </RenderIf>

      <EditCaseTour />
    </>
  )
}

export default AddCaseFormContent;
